import { render, staticRenderFns } from "./NewVehicleEntity.vue?vue&type=template&id=84463ac6&scoped=true&"
import script from "./NewVehicleEntity.vue?vue&type=script&lang=js&"
export * from "./NewVehicleEntity.vue?vue&type=script&lang=js&"
import style0 from "./NewVehicleEntity.vue?vue&type=style&index=0&id=84463ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84463ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84463ac6')) {
      api.createRecord('84463ac6', component.options)
    } else {
      api.reload('84463ac6', component.options)
    }
    module.hot.accept("./NewVehicleEntity.vue?vue&type=template&id=84463ac6&scoped=true&", function () {
      api.rerender('84463ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Entities/NewVehicleEntity.vue"
export default component.exports